/**
 * Strips spaces, country code (+91 / 91), and all non-digit characters
 * from a phone number string, returning at most 10 digits.
 *
 * Examples:
 *   "+91 97543 57667"  →  "9754357667"
 *   "97543 5766"       →  "975435766"
 *   "91 9876543210"    →  "9876543210"
 */
export const sanitizeMobile = (value) => {
    let digits = String(value).replace(/\D/g, '');
    if (digits.length > 10 && digits.startsWith('91')) {
        digits = digits.slice(2);
    }
    return digits.slice(0, 10);
};
